// Fetches release tags for the Software page's desired-version dropdowns via the
// `software-releases` Supabase edge function, which holds the GitHub token
// server-side (see IT/SECRETS-MIGRATION.md, Tier 1). No GitHub token ships in
// the operator build anymore. On any failure (offline, function down, repo with
// no releases) callers fall back to manual "Custom…" entry, so this is
// best-effort.

import { supabase } from '../lib/supabase';
import { SoftwareComponent } from '../types/database';

export interface ReleaseInfo {
  tag_name: string;
  name: string;
  published_at: string;
  prerelease: boolean;
}

interface SoftwareReleasesResponse {
  component: SoftwareComponent;
  repo: string;
  versions: ReleaseInfo[];
}

// Returns release tag names (e.g. "v1.2.60") for a component, newest first.
// Returns [] on any error so the UI can fall back to manual entry.
export async function fetchVersionsForComponent(component: SoftwareComponent): Promise<string[]> {
  try {
    const { data, error } = await supabase.functions.invoke<SoftwareReleasesResponse>(
      'software-releases',
      { body: { component } },
    );
    if (error) throw error;
    return (data?.versions ?? []).map((r) => r.tag_name);
  } catch (err) {
    console.warn(`Could not fetch ${component} releases:`, err);
    return [];
  }
}
